import { FocusableElement, Node } from '@react-types/shared'
import React, { ComponentType, DOMAttributes, ReactNode, ReactElement } from 'react'
import { Icon } from '../../../../old/icon'
import { Box, Flex, Text } from '../../../core-components'
import { EndContentProvider } from '../../data'
import { DefaultSelectedText } from './DefaultSelectedText'
import { SelectedText } from './StyledSelectTrigger'
import { DynamicItem } from './dynamicItemUtils'

export const BaseSelectValue = ({
  startIcon,
  valueProps,
  hasLabelInside,
  isRequired,
  labelProps,
  label,
  rootValueNode,
  selectedText = DefaultSelectedText,
  valuePath,
  value,
  placeholder,
  onLeafEndContent,
}: {
  hasLabelInside: boolean
  isRequired?: boolean
  label: ReactNode
  labelProps: DOMAttributes<FocusableElement>
  placeholder: ReactNode
  rootValueNode: Node<DynamicItem> | null | undefined
  selectedText?: (
    selectedItem: Node<DynamicItem>,
    valuePath: readonly string[] | undefined,
    value?: string,
    onLeafEndContent?: (endContent: ReactNode | undefined) => void
  ) => ReactElement
  startIcon?: ComponentType
  value?: string
  valuePath?: readonly string[]
  valueProps: DOMAttributes<FocusableElement>
  onLeafEndContent?: (endContent: ReactNode | undefined) => void
}) => (
  <Flex alignItems='center' gap={3} flexGrow={1} minWidth={0}>
    {startIcon && <Icon icon={startIcon} color='icon/indicator' w={4} h={4} />}
    <EndContentProvider value={{ iconColor: 'icon/indicator', size: 3 }}>
      <Box {...valueProps} minWidth={0} mr={3} flexGrow={1}>
        {hasLabelInside && (
          <Flex
            display='flex'
            gap={3}
            alignItems='start'
            {...labelProps}
            style={{ pointerEvents: 'none' }}
          >
            <Text
              mb={2}
              display='block'
              textStyle='form-label-inline'
              color='text/form-label-moderate'
            >
              {label}
            </Text>
            {isRequired && (
              <Text textStyle='form-label-inline' color='text/action-caution'>
                *
              </Text>
            )}
          </Flex>
        )}
        {rootValueNode ? (
          selectedText(rootValueNode, valuePath, value, onLeafEndContent)
        ) : (
          <BaseSelectPlaceholder placeholder={placeholder} />
        )}
      </Box>
    </EndContentProvider>
  </Flex>
)

const BaseSelectPlaceholder = ({ placeholder }: { placeholder: React.ReactNode }) => {
  return typeof placeholder === 'string' ? (
    <SelectedText display='block' color='text/form-placeholder' textStyle='form-value'>
      {placeholder}
    </SelectedText>
  ) : (
    <>{placeholder}</>
  )
}
